/*
 * Flaschenbauer Konfigurator (Glas) - Phase 2
 * Section-gescopt, re-init-fest (shopify:section:load), defer geladen.
 * Tier-Parser spiegelt 1:1 die Cart-Transform-Function (Untergrenze/"ab"-Logik, v9) -> Anzeige == Berechnung.
 * Semantik-Fix 03.07.2026 (Fall B): threshold = Untergrenze (qty >= threshold), darunter Basispreis.
 * Anzeige im "ab"-Stil ("ab 1 | ab 10 | ab 25 ...") — Entscheidung Daniel 03.07. (abends),
 * ersetzt das kurzzeitige Range-Format. Anzeige-Filter: nur preis-senkende Stufen.
 * Setzt nie selbst einen Preis im Cart; Glas + jeder Deckel/Zubehoer als separate Line-Items
 * (ohne _bundle-Property, damit gleiche Varianten im Warenkorb hochzaehlen).
 */
(function () {
  'use strict';

  function eur(n) { return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €'; }

  // Untergrenze/"ab"-Logik, identisch zur Function (volume-transform/src/run.js v9)
  function parseTiers(raw) {
    if (!raw || typeof raw !== 'string') return [];
    var rawSegments = raw.split(/[,;]/), segments = [];
    for (var i = 0; i < rawSegments.length; i++) {
      var seg = rawSegments[i].trim();
      if (!seg) continue;
      if (seg.indexOf(':') !== -1) segments.push(seg);
      else if (segments.length > 0) segments[segments.length - 1] += '.' + seg;
    }
    return segments.map(function (s) {
      var p = s.split(':'); if (p.length !== 2) return null;
      var t = parseInt(p[0].trim(), 10), pr = parseFloat(p[1].trim().replace(',', '.'));
      // pr <= 0: 0-Euro-Stufen sind immer Datenfehler -> verwerfen (Audit K1, 03.07.)
      if (isNaN(t) || isNaN(pr) || t < 1 || pr <= 0) return null;
      return { threshold: t, price: pr };
    }).filter(Boolean).sort(function (a, b) { return a.threshold - b.threshold; });
  }
  // Hoechster Tier mit threshold <= q; unter dem ersten Threshold gilt der Basispreis (null).
  function findTier(tiers, q) {
    if (!tiers.length) return null;
    var match = null;
    for (var i = 0; i < tiers.length; i++) {
      if (q >= tiers[i].threshold) match = tiers[i];
      else break; // aufsteigend sortiert
    }
    return match;
  }
  // "ab"-Wert eines Tiers = sein eigener Threshold (Untergrenze).
  function abFrom(tiers, i) { return tiers[i].threshold; }
  // Anzeige-Filter (Entscheidung 03.07., Panel): nur Stufen zeigen, die den Preis
  // wirklich SENKEN (gleiche Guard-Semantik wie die Cart-Transform-Function).
  // Verhindert irrefuehrende Zeilen bei Basispreis-Abweichungen (z. B. MILCH001-1:
  // Basis 0,88 aber Stufe "ab 8: 0,93" -> wuerde nie berechnet, darf nie angezeigt werden).
  function applicableTiers(tiers, base) {
    return tiers.filter(function (t) { return t.price < base - 0.0001; });
  }

  function fetchConfig() {
    if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.fetchConfig === 'function') {
      var c = FoxTheme.utils.fetchConfig('javascript'); c.method = 'POST'; return c;
    }
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
  }
  function readJSON(el) { if (!el) return []; try { return JSON.parse(el.textContent || '[]'); } catch (e) { return []; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function stars(r) { var full = Math.round(r); var o = ''; for (var i = 1; i <= 5; i++) o += i <= full ? '★' : '☆'; return o; }

  // Taxonomie-Farb-Label -> Hex fuer kleine Swatch-Punkte. Unbekannt -> '' (kein Punkt).
  var FB_COLORS = {
    'blau': '#2F5FA6', 'dunkelblau': '#1F3D73', 'hellblau': '#7FA8D6',
    'gold': '#C9A227', 'silber': '#B4B8BC', 'grau': '#9A9A95', 'anthrazit': '#3A3A38',
    'weiss': '#F4F2EE', 'weiß': '#F4F2EE', 'schwarz': '#1C1C1A',
    'rot': '#B5402F', 'bordeaux': '#6E2433', 'grün': '#3E7C53', 'gruen': '#3E7C53',
    'gelb': '#E3B341', 'orange': '#D77A2B', 'braun': '#7A5230', 'beige': '#D9CDB6',
    'rosa': '#D78FA6', 'pink': '#CC4E84', 'lila': '#7A5AA6', 'violett': '#7A5AA6',
    'transparent': '#E6E9EC', 'klar': '#E6E9EC',
    'blue': '#2F5FA6', 'navy': '#1F3D73', 'silver': '#B4B8BC', 'white': '#F4F2EE', 'black': '#1C1C1A',
    'red': '#B5402F', 'green': '#3E7C53', 'yellow': '#E3B341', 'grey': '#9A9A95', 'gray': '#9A9A95', 'clear': '#E6E9EC',
    'brown': '#7A5230', 'beige': '#D9CDB6', 'pink': '#CC4E84', 'purple': '#7A5AA6', 'orange': '#D77A2B',
    'bronze': '#8C6A3F', 'turquoise': '#3AA6A0', 'teal': '#2E7D7A', 'ivory': '#F2EBDD', 'cream': '#F2EBDD', 'rose gold': '#D8A48F'
  };
  // Farbe kann mehrere pipe-getrennte Taxonomie-Label enthalten (Farbe + Muster, z. B. "Gold|Geometrisch").
  // Ersten Wert nehmen, der einer bekannten Farbe entspricht; Muster ohne Farb-Mapping werden ignoriert.
  function fbColorHex(label) {
    if (!label) return '';
    var parts = String(label).toLowerCase().split('|');
    for (var i = 0; i < parts.length; i++) { var k = parts[i].trim(); if (FB_COLORS[k]) return FB_COLORS[k]; }
    return '';
  }
  // Fallback: Farbe aus dem deutschen Produktnamen. Bewusst nur deutsche Farbwoerter,
  // damit z. B. "BlueSeal" im Namen nicht faelschlich als Blau zaehlt. Spezifische zuerst.
  var FB_NAME_COLORS = ['anthrazit', 'dunkelblau', 'hellblau', 'bordeaux', 'violett', 'transparent', 'schwarz', 'silber', 'blau', 'gold', 'grau', 'weiß', 'weiss', 'rot', 'grün', 'gruen', 'gelb', 'orange', 'braun', 'beige', 'rosa', 'pink', 'lila', 'klar'];
  function fbColorFromName(name) { if (!name) return ''; var s = String(name).toLowerCase(); for (var i = 0; i < FB_NAME_COLORS.length; i++) { if (s.indexOf(FB_NAME_COLORS[i]) !== -1) return FB_COLORS[FB_NAME_COLORS[i]] || ''; } return ''; }
  function fbIsHex(v) { return /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(v || '').trim()); }
  // Punktfarbe: 1) Marken-Mapping aus dem Farb-Label, 2) echter Taxonomie-Hex (color-Feld),
  // 3) lockere Namenserkennung. So bekommt jeder Artikel mit hinterlegter Farbe einen Punkt.
  function fbDot(item) {
    return fbColorHex(item.color) || (fbIsHex(item.colorhex) ? String(item.colorhex).trim() : '') || fbColorFromName(item.name);
  }

  function initOne(root) {
    if (!root || root.__fbInit) return;
    root.__fbInit = true;

    var basePrice = parseInt(root.getAttribute('data-base-price') || '0', 10) / 100;
    // Audit W1 (03.07.): BERECHNUNG auf der ungefilterten Liste mit Function-Guard
    // (identisch zu run.js), Anzeige-Filter nur fuer die sichtbare Tabelle.
    var gTiersFull = parseTiers(root.getAttribute('data-volume-prices') || '');
    var gTiers = applicableTiers(gTiersFull, basePrice);
    var variantId = root.getAttribute('data-variant-id');
    var available = root.getAttribute('data-available') === 'true';
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    // PDP-URL: das Mobile-Sheet rendert darueber und kennt so den Hauptartikel (Fix 09.07.).
    var productUrl = root.getAttribute('data-product-url') || '';
    var unitS = root.getAttribute('data-unit-singular') || 'Stück';
    var unitP = root.getAttribute('data-unit-plural') || 'Stück';
    var showProgress = root.getAttribute('data-show-progress') === 'true';

    // Ausverkaufte Artikel gar nicht erst im Modal anbieten (verhindert fehlschlagenden Warenkorb-Add).
    // Die crawlbaren Kompatibilitaets-Links bleiben serverseitig (im Liquid) fuer alle Produkte erhalten.
    function avail(x) { return x && x.available !== false; }
    var caps = readJSON(root.querySelector('[data-fb-caps]')).filter(avail);
    var accs = readJSON(root.querySelector('[data-fb-accs]')).filter(avail);
    function catalog(t) { return t === 'lid' ? caps : accs; }
    function typeLabel(t) { return t === 'lid' ? 'Verschlüsse' : 'Zubehör'; }
    // Falls eine Kategorie nach dem Filtern leer ist, den zugehoerigen "waehlen"-Schalter ausblenden.
    ['lid', 'acc'].forEach(function (t) {
      if (!catalog(t).length) {
        var ob = root.querySelector('[data-fb-open="' + t + '"]');
        var row = ob && ob.closest ? ob.closest('.fb-cpick') : null;
        if (row) row.style.display = 'none';
      }
    });

    var set = { lid: [], acc: [] }; // {item, qty}

    var $ = function (s) { return root.querySelector(s); };
    var input = $('[data-fb-qty]');
    var unitEl = $('[data-fb-unit]');
    var staffelEl = $('[data-fb-staffel]');
    var staffelRow = $('[data-fb-staffel-row]');
    var itemsEl = $('[data-fb-items]');
    var setEl = $('[data-fb-set]');
    var pTitle = root.getAttribute('data-fb-title') || '';
    var barEl = $('[data-fb-bar]'); var barText = $('[data-fb-bar-text]'); var barFill = $('[data-fb-bar-fill]'); var barTrack = $('[data-fb-bar-track]');
    var atcEl = $('[data-fb-atc]'); var atcPrice = $('[data-fb-atc-price]'); var errEl = $('[data-fb-error]');

    // Keine anwendbare (preis-senkende) Stufe -> Chip-Zeile gar nicht zeigen.
    // Tritt auf, wenn alle gepflegten Stufen >= Grundpreis sind (Datenfehler, z. B. vertauschte Werte).
    // Sonst ist die Staffel ab Start sichtbar: der Rabatt liegt nicht mehr hinter einem Tap (09.07.).
    // Kein matchMedia mehr — der alte Teaser wurde einmalig nach Viewport gesetzt und clippte,
    // sobald die Konfigurator-Spalte schmaler war als der Breakpoint.
    if (staffelEl) {
      if (!gTiers.length) staffelEl.setAttribute('hidden', '');
      else {
        staffelEl.removeAttribute('hidden');
        // Zeilen kommen serverseitig aus dem Snippet (crawlbar). buildStaffel() ist nur
        // Fallback, falls die Tabelle leer ankommt (z. B. Liquid-Parsing weicht ab).
        if (!staffelRow || !staffelRow.children.length) buildStaffel();
      }
    }

    // ---- Preis-Helfer ----
    function tiersFullOf(item) { if (!item.__tf) item.__tf = parseTiers(item.vp); return item.__tf; }
    function tiersOf(item) { if (!item.__t) item.__t = applicableTiers(tiersFullOf(item), (item.price || 0) / 100); return item.__t; }
    // Guard wie die Function (run.js): Staffelpreis senkt nur, er erhoeht nie ueber den Basispreis.
    function itemUnit(item, q) { var base = (item.price || 0) / 100; var t = tiersFullOf(item); if (t.length) { var f = findTier(t, q); if (f && f.price < base - 0.0001) return f.price; } return base; }
    function itemFrom(item) { var base = (item.price || 0) / 100; var t = tiersOf(item); if (t.length) { var p = t[t.length - 1].price; if (p < base - 0.0001) return p; } return base; }
    function glassUnit(q) { if (gTiersFull.length) { var t = findTier(gTiersFull, q); if (t && t.price < basePrice - 0.0001) return t.price; } return basePrice; }
    var QTY_MAX = 100000;
    function getQty() { var q = parseInt((input.value || '1').replace(/[^0-9]/g, ''), 10); if (isNaN(q) || q < 1) q = 1; if (q > QTY_MAX) q = QTY_MAX; return q; }
    function unitName(q) { return q === 1 ? unitS : unitP; }
    function sumQ(t) { return set[t].reduce(function (s, e) { return s + e.qty; }, 0); }
    function sumT(t) { return set[t].reduce(function (s, e) { return s + itemUnit(e.item, e.qty) * e.qty; }, 0); }

    // ---- Schritt 1 + Set rendern ----
    // Die Staffel-Tabelle kommt serverseitig aus dem Snippet (crawlbar). buildStaffel() ist nur
    // Fallback, falls die Zeilen leer ankommen. renderStaffel() haengt danach ausschliesslich
    // is-on/aria-current um -> kein innerHTML pro Render, keine Reflow-Kaskade.
    function staffelBtns() { return staffelRow ? staffelRow.querySelectorAll('[data-fb-stier]') : []; }
    function rowHTML(thr, price, unit, save) {
      return '<button type="button" class="fb-staffel__row" data-fb-stier="' + thr + '" aria-current="false"'
        + ' aria-label="Menge auf ' + thr + ' ' + unit + ' setzen, ' + eur(price) + ' pro ' + unitS
        + (save > 0 ? ', ' + save + ' Prozent sparen' : '') + '">'
        + '<span class="fb-staffel__q">ab ' + thr + ' ' + unit + '</span>'
        + '<span class="fb-staffel__p num">' + eur(price) + ' / Stk</span>'
        + '<span class="fb-staffel__save">' + (save > 0 ? '−' + save + ' %' : '') + '</span>'
        + '</button>';
    }
    function buildStaffel() {
      if (!staffelRow || !gTiers.length) return;
      var rows = gTiers[0].threshold > 1 ? rowHTML(1, basePrice, unitS, 0) : '';
      rows += gTiers.map(function (t) {
        var save = basePrice > 0 ? Math.round((1 - t.price / basePrice) * 100) : 0;
        return rowHTML(t.threshold, t.price, unitP, save);
      }).join('');
      staffelRow.innerHTML = rows;
    }
    function renderStaffel(q) {
      if (!staffelRow || !gTiers.length) return;
      var active = findTier(gTiers, q);
      var onThr = active ? active.threshold : 1;
      var hitHidden = false;
      [].forEach.call(staffelBtns(), function (c) {
        var on = parseInt(c.getAttribute('data-fb-stier'), 10) === onThr;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && c.hasAttribute('hidden')) hitHidden = true;
      });
      // Erreicht die Menge eine eingeklappte Stufe, klappt die Tabelle zwangsweise auf: die
      // aktive Zeile darf nie unsichtbar sein (sonst wirkt der Rabatt, ohne dass er belegt
      // wird). Solange das so ist, wird der Zuklapp-Button gesperrt (locked) — sonst koennte
      // der Kunde genau die Stufe verstecken, die gerade greift. Faellt die Menge wieder
      // unter die erste Extra-Stufe, wird der Button entsperrt (Fix 09.07.).
      if (hitHidden) { expandStaffel(true); } else { setStaffelLock(false); }
    }
    // Aufklapper 09.07.: war eine Einbahnstrasse (Button wurde nach dem Klick versteckt).
    // Jetzt echtes Toggle mit gemerktem Ausgangstext.
    var staffelLocked = false;
    function staffelMoreBtn() { return root.querySelector('[data-fb-staffel-more]'); }
    function setStaffelLock(on) {
      staffelLocked = !!on;
      var more = staffelMoreBtn();
      if (more) more.hidden = staffelLocked;
    }
    function setStaffelExpanded(on) {
      if (!staffelRow) return;
      var extras = staffelRow.querySelectorAll('.fb-staffel__row--extra');
      if (!extras.length) return;
      [].forEach.call(extras, function (c) {
        if (on) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
      });
      var more = staffelMoreBtn();
      if (!more) return;
      more.setAttribute('aria-expanded', on ? 'true' : 'false');
      var txt = more.querySelector('[data-fb-staffel-more-txt]');
      if (txt) {
        if (!txt.getAttribute('data-fb-more-label')) txt.setAttribute('data-fb-more-label', txt.textContent);
        txt.textContent = on ? 'Weniger anzeigen' : txt.getAttribute('data-fb-more-label');
      }
      more.classList.toggle('is-expanded', on);
    }
    function expandStaffel(lock) {
      setStaffelExpanded(true);
      if (lock) setStaffelLock(true);
    }
    function toggleStaffel() {
      if (staffelLocked) return;
      var more = staffelMoreBtn();
      setStaffelExpanded(!(more && more.getAttribute('aria-expanded') === 'true'));
    }
    function renderProgress(q) {
      if (!showProgress || !barEl || !gTiers.length) return;
      var next = null, prevMin = 1;
      for (var i = 0; i < gTiers.length; i++) { var from = abFrom(gTiers, i); if (q < from) { next = { from: from, price: gTiers[i].price }; break; } prevMin = from; }
      barEl.hidden = false;
      if (next) {
        var prog = Math.max(0, Math.min(1, (q - prevMin) / (next.from - prevMin)));
        // Track (Schiene) IMMER sichtbar, damit der Fortschritt bis zur naechsten Staffel
        // durchgehend erkennbar ist (15.07.: Balken verschwand beim Stufenwechsel, weil der
        // Track bei prog<0.04 versteckt wurde). Fill exakt proportional, kein kuenstlicher Floor:
        // am Stufen-Start 0 % (nur Schiene), fuellt sich ehrlich bis zur naechsten Staffel.
        if (barTrack) barTrack.hidden = false;
        barFill.style.width = (prog * 100).toFixed(0) + '%';
        barText.innerHTML = 'Noch <b>' + (next.from - q) + ' ' + esc(unitName(next.from - q)) + '</b> bis ' + eur(next.price) + ' / Stk.';
      } else { if (barTrack) barTrack.hidden = false; barFill.style.width = '100%'; barText.innerHTML = '<b>Beste Staffel erreicht.</b>'; }
    }
    function renderCpickSum(t) {
      var el = root.querySelector('[data-fb-sum="' + t + '"]'); if (!el) return;
      var l = set[t];
      var lidNudge = t === 'lid' ? root.querySelector('[data-fb-lid-nudge]') : null;
      if (!l.length) {
        // Verschluss ohne Auswahl: Nudge "Ohne Verschluss geliefert" sichtbar lassen,
        // Zusammenfassung nur das garantiert-passend-Badge (kein blasses "Optional").
        el.innerHTML = (t === 'lid') ? '<span class="fb-cpick__pass">✓ garantiert passend</span>' : '<span class="fb-cpick__opt">Optional</span>';
        if (lidNudge) lidNudge.hidden = false;
        var b0 = root.querySelector('[data-fb-open="' + t + '"]'); if (b0) b0.textContent = typeLabel(t) + ' wählen';
        return;
      }
      if (lidNudge) lidNudge.hidden = true;
      var label = l.length === 1
        ? esc(l[0].item.name)
        : 'Mehrere ' + (t === 'lid' ? 'Verschlüsse' : 'Zubehörteile') + ' hinzugefügt';
      var dots = l.map(function (e) { var hx = fbDot(e.item); return hx ? '<span class="fb-cpick__dot" style="background:' + hx + '"></span>' : ''; }).join('');
      var dotsHTML = dots ? ' <span class="fb-cpick__dots">' + dots + '</span>' : '';
      el.innerHTML = label + dotsHTML + ' <small>· ' + sumQ(t) + ' Stück · ' + eur(sumT(t)) + '</small>';
      var btn = root.querySelector('[data-fb-open="' + t + '"]'); if (btn) btn.textContent = typeLabel(t) + ' ändern';
    }
    function render() {
      var q = getQty();
      var gu = glassUnit(q), gLine = gu * q;
      var total = gLine + sumT('lid') + sumT('acc');
      if (unitEl) {
        if (gu < basePrice - 0.0001) {
          unitEl.innerHTML = 'Angewendeter Staffelpreis: <b class="num">' + eur(gu) + '</b> / Stück';
          unitEl.style.display = '';
        } else {
          unitEl.innerHTML = '';
          unitEl.style.display = 'none';
        }
      }
      renderStaffel(q);
      // Variante A (03.07.): Set-Kasten nur zeigen, wenn er Information traegt
      // (Menge > 1 oder Verschluss/Zubehoer gewaehlt). Positionen als Mini-Beleg,
      // Gesamtpreis steht ausschliesslich im ATC-Button.
      var trivial = q <= 1 && !sumQ('lid') && !sumQ('acc');
      if (setEl) {
        if (trivial) {
          setEl.hidden = true;
          setEl.classList.remove('is-in');
        } else if (setEl.hidden) {
          setEl.hidden = false;
          setEl.classList.remove('is-in');
          void setEl.offsetWidth;
          setEl.classList.add('is-in');
        }
      }
      if (itemsEl) {
        var lines = [];
        var gSave = basePrice > 0 && gu < basePrice - 0.0001 ? Math.round((1 - gu / basePrice) * 100) : 0;
        lines.push('<div class="fb-set__line"><span>' + q + '&nbsp;&times; ' + esc(pTitle || unitName(q)) + '</span><span class="num">' + eur(gu) + '/Stk' + (gSave > 0 ? ' <b class="fb-set__save">−' + gSave + ' %</b>' : '') + '</span></div>');
        ['lid', 'acc'].forEach(function (t) {
          set[t].forEach(function (e) {
            lines.push('<div class="fb-set__line"><span>' + e.qty + '&nbsp;&times; ' + esc(e.item.name) + '</span><span class="num">' + eur(itemUnit(e.item, e.qty)) + '/Stk</span></div>');
          });
        });
        itemsEl.innerHTML = lines.join('');
      }
      if (atcPrice) atcPrice.textContent = '· ' + eur(total);
      // Gratis-Aktion ab Warenwert (fb-gift-promo.js): Auswahlwert fuer die PDP-Box.
      root.setAttribute('data-fb-sel-cents', String(Math.round(total * 100)));
      root.dispatchEvent(new CustomEvent('fb:selection', { bubbles: true }));
      renderProgress(q);
      renderCpickSum('lid'); renderCpickSum('acc');
    }
    function setQty(q) { if (q < 1) q = 1; input.value = q; render(); }

    // ---- Schritt 1 Events ----
    root.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-fb-q]');
      if (stepBtn && root.contains(stepBtn) && !e.target.closest('[data-fb-modal]')) { setQty(getQty() + (parseInt(stepBtn.getAttribute('data-fb-q'), 10) || 0)); return; }
      // Staffel-Zeile antippen = Menge direkt auf die Stufe setzen (09.07.). Ein Tap statt
      // aufklappen -> lesen -> Stepper 50x druecken. Modal-Chips (data-fb-tier) bleiben unberuehrt.
      var sRow = e.target.closest('[data-fb-stier]');
      if (sRow && !e.target.closest('[data-fb-modal]')) {
        var sthr = parseInt(sRow.getAttribute('data-fb-stier'), 10);
        if (!isNaN(sthr)) setQty(Math.min(QTY_MAX, Math.max(1, sthr)));
        return;
      }
      if (e.target.closest('[data-fb-staffel-more]')) { toggleStaffel(); return; }
      var openBtn = e.target.closest('[data-fb-open]');
      if (openBtn) { openModal(openBtn.getAttribute('data-fb-open')); return; }
      if (e.target.closest('[data-fb-atc]')) { addToCart(); return; }
    });
    input.addEventListener('input', render);
    input.addEventListener('change', function () { setQty(getQty()); });

    // ================= MODAL =================
    var modal = $('[data-fb-modal]'), ov = $('[data-fb-ov]');
    var mTrack = $('[data-fb-track]'), mDet = $('[data-fb-mdet]'), mList = $('[data-fb-mlist]');
    var mTitle = $('[data-fb-mtitle]'), mPass = $('[data-fb-mpass]'), mListH = $('[data-fb-mlisth]'), mHint = $('[data-fb-mhint]');
    var mDone = modal.querySelector('[data-fb-mdone]');
    var mType = 'lid', mSel = 0, mSnapshot = [], lastTrigger = null;
    // Doppel-Event-Schutz fuer die Karten-Auswahl (merkt letzten Toggle: Index + Zeit).
    var lastToggle = { i: -1, t: 0 };

    // ---- Portal: Modal ans <body> haengen ----
    // Hintergrund: In Hyper ist ein Vorfahre des Konfigurators (sticky-element bzw.
    // scroll-reveal-Wrapper) mit transform/will-change versehen. Ein solcher Vorfahre
    // wird zum Containing Block fuer position:fixed, wodurch top/bottom NICHT mehr
    // viewportrelativ sind und der Modal-Kopf oben abgeschnitten wird. Loesung: Modal
    // in das Overlay einhaengen und das Overlay direkt ans <body> portieren. Damit ist
    // der Containing Block garantiert der Viewport. Die Section (root) ist die genau eine
    // Konfigurator-Instanz pro PDP, daher entsteht pro Section genau ein Modal.
    if (modal && ov && !ov.__fbPortal) {
      ov.__fbPortal = true;
      // Re-Init-Festigkeit: bei shopify:section:load wird die alte Section ersetzt,
      // das alte portierte Overlay bliebe sonst verwaist am <body>. Vorher aufraeumen.
      var secId = root.getAttribute('data-section-id') || '';
      if (secId) {
        ov.setAttribute('data-fb-ov-section', secId);
        var stale = document.querySelectorAll('body > [data-fb-ov-section="' + secId + '"]');
        for (var s = 0; s < stale.length; s++) stale[s].remove();
        // Falls beim Re-Init (shopify:section:load) ein altes Modal offen war, bleibt sonst
        // der Body-Scroll-Lock haengen. Sicherheitshalber entfernen.
        document.body.classList.remove('fb-lock');
      }
      // eigenstaendige Scope-Klasse, da die .fb-configurator-Selektoren nach dem
      // Verschieben nicht mehr greifen wuerden (Tokens sind in der CSS auf
      // .fb-modal-root dupliziert).
      ov.classList.add('fb-modal-root');
      ov.appendChild(modal);        // Modal als Flow-Kind ins Overlay (Flex zentriert)
      document.body.appendChild(ov); // Overlay ans Ende des <body>
    }

    function active() { return catalog(mType)[mSel]; }
    // BFSG: Hintergrund fuer Tastatur/Screenreader stilllegen, solange das Modal offen ist.
    function setBgInert(on) {
      var kids = document.body.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el === ov) continue;
        if (on) { el.setAttribute('aria-hidden', 'true'); try { el.inert = true; } catch (err) {} }
        else { el.removeAttribute('aria-hidden'); try { el.inert = false; } catch (err) {} }
      }
    }
    function openModal(type) {
      if (!catalog(type).length) return;
      lastTrigger = document.activeElement; // Fokus-Rueckgabe-Ziel merken
      mType = type; mSel = 0; lastToggle = { i: -1, t: 0 };
      // Snapshot des aktuellen Stands: Modal-Aenderungen sind bis "übernehmen" nur ein Entwurf.
      mSnapshot = set[type].map(function (e) { return { item: e.item, qty: e.qty }; });
      mTitle.textContent = type === 'lid' ? 'Verschluss wählen' : 'Zubehör wählen';
      mPass.style.display = type === 'lid' ? '' : 'none';
      mHint.textContent = 'Wähle ' + (type === 'lid' ? 'den passenden Verschluss' : 'das passende Zubehör') + '. Mehrere möglich.';
      renderStrip(); renderDet(); renderList();
      ov.classList.add('is-open'); modal.classList.add('is-open');
      document.body.classList.add('fb-lock');
      setBgInert(true);
      // Fokus in den Dialog (Schliessen-Button) + Pfeile erst nach Layout syncen.
      requestAnimationFrame(function () {
        var x = modal.querySelector('[data-fb-mclose]'); if (x) x.focus();
        syncArrows();
      });
    }
    function closeModal() {
      ov.classList.remove('is-open'); modal.classList.remove('is-open');
      document.body.classList.remove('fb-lock');
      setBgInert(false);
      // Fokus zurueck auf den ausloesenden "…wählen"-Button.
      if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus(); } catch (err) {} }
    }
    // Transaktional (Daniel 07.07.): Auswahl wird erst bei "übernehmen" auf die Kaufbox angewendet.
    // Abbrechen (X / Overlay / Esc) verwirft die Modal-Aenderungen und stellt den Stand vor dem Öffnen her.
    function commitModal() { render(); closeModal(); }
    function cancelModal() { set[mType] = mSnapshot; render(); closeModal(); }
    function imgHTML(it) {
      return it.img
        ? '<img src="' + esc(it.img) + '" alt="' + esc(it.name) + '" loading="lazy">'
        : '<span class="fb-scard__ph"></span>';
    }
    function inSet(it) { return set[mType].some(function (e) { return e.item === it; }); }
    var badgeSVG = '<span class="fb-scard__badge" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>';
    function renderStrip() {
      mTrack.innerHTML = catalog(mType).map(function (it, i) {
        return '<button type="button" class="fb-scard' + (i === mSel ? ' is-sel' : '') + (inSet(it) ? ' is-added' : '') + '" data-fb-card="' + i + '" aria-pressed="' + (inSet(it) ? 'true' : 'false') + '"><span class="fb-scard__im">' + imgHTML(it) + badgeSVG + '</span><span class="fb-scard__n">' + esc(it.name) + '</span></button>';
      }).join('');
    }
    function updateBadges() {
      var cat = catalog(mType);
      [].forEach.call(mTrack.children, function (c, i) {
        var added = inSet(cat[i]);
        c.classList.toggle('is-added', added);
        c.setAttribute('aria-pressed', added ? 'true' : 'false');
        var b = c.querySelector('.fb-scard__badge');
        if (b) b.style.display = added ? 'grid' : 'none';
      });
    }
    function syncArrows() {
      var prev = modal.querySelector('[data-fb-prev]'), next = modal.querySelector('[data-fb-next]');
      // Kein Overflow (alle Karten passen sichtbar) -> Pfeile ganz ausblenden statt nur deaktivieren.
      var overflow = mTrack.scrollWidth - mTrack.clientWidth > 2;
      var max = mTrack.scrollWidth - mTrack.clientWidth - 2;
      if (prev) { prev.classList.toggle('fb-gal__arr--off', !overflow); prev.disabled = mTrack.scrollLeft <= 2; }
      if (next) { next.classList.toggle('fb-gal__arr--off', !overflow); next.disabled = mTrack.scrollLeft >= max; }
    }
    // Standard-Menge beim Hinzufuegen: Verschluesse = Glas-Menge (1 pro Glas),
    // Zubehoer = 1 (Upsell wie Buch nicht automatisch hochzaehlen; "wie Gläser"-Chip bleibt manuell).
    function defaultQty() { return mType === 'lid' ? getQty() : 1; }
    // Karte antippen = Auswahl togglen (Daniel 07.07.): kein separater "Hinzufuegen"-Schritt mehr.
    function selectCard(i) {
      var n = Math.max(0, Math.min(catalog(mType).length - 1, i));
      mSel = n;
      [].forEach.call(mTrack.children, function (c, j) { c.classList.toggle('is-sel', j === mSel); });
      var card = mTrack.children[mSel]; if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      // Doppelklick-/Doppel-Event-Schutz (Edge/Windows: viele klicken aus Gewohnheit doppelt;
      // Touch erzeugt teils Ghost-Clicks): denselben Card-Toggle nicht binnen 400 ms zweimal
      // werten. Sonst hebt sich Hinzufuegen/Entfernen auf und die Auswahl bleibt scheinbar
      // leer ("noch nichts gewaehlt", obwohl angeklickt) -> gemeldeter Edge-Bug 16.07.
      // Fokus/Vorschau (is-sel, Detail) wurde oben bereits gesetzt, nur der Toggle wird geschluckt.
      var __now = Date.now();
      if (lastToggle.i === mSel && (__now - lastToggle.t) < 400) { renderDet(); return; }
      lastToggle = { i: mSel, t: __now };
      var it = catalog(mType)[mSel];
      var idx = -1;
      for (var k = 0; k < set[mType].length; k++) { if (set[mType][k].item === it) { idx = k; break; } }
      if (idx >= 0) set[mType].splice(idx, 1);
      else set[mType].push({ item: it, qty: defaultQty() });
      renderDet(); renderList();
    }
    // Detail = reine Info zur fokussierten Karte (kein Tab, keine Menge, kein Add-Button mehr).
    function renderDet() {
      var it = active(); if (!it) return;
      var isLid = mType === 'lid';
      var from = itemFrom(it);
      // Bei Verschluessen wandert die Muendung in die Passt-Zeile; Zubehoer behaelt sie in der Spec-Zeile.
      var spec = [];
      if (!isLid && it.muendung) spec.push(esc(it.muendung));
      if (it.material) spec.push(esc(it.material));
      var head = '<div class="fb-mdet__h"><div><div class="fb-mdet__n">' + esc(it.name) + '</div>' +
        (it.sku ? '<div class="fb-mdet__sku">Art.-Nr. ' + esc(it.sku) + '</div>' : '') +
        (spec.length ? '<div class="fb-mdet__spec">' + spec.join(' · ') + '</div>' : '') + '</div>' +
        '<div class="fb-mdet__r"><div class="fb-mdet__price">ab <b class="num">' + eur(from) + '</b></div>' +
        (it.ratingCount > 0 ? '<div class="fb-mdet__rate"><span class="fb-mdet__s">' + stars(it.rating) + '</span> ' + esc(String(it.rating).replace('.', ',')) + ' · ' + esc(String(it.ratingCount)) + '</div>' : '') +
        '</div></div>';
      // Schnell-Mengen-Chips: "wie Gläser" (immer) + Rabattstufen (nur bei echten preis-senkenden
      // Stufen). Antippen setzt die Menge der fokussierten Karte; aktive Rabattstufe hervorgehoben.
      var t = tiersOf(it);
      var glassQ = getQty();
      var syncIcon = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/></svg>';
      var chips = '<button type="button" class="fb-mstaffel__t fb-mstaffel__t--glass" data-fb-glass aria-label="Menge wie Gläser (' + glassQ + ' Stück)">' + syncIcon + 'wie Gläser (' + glassQ + ')</button>';
      if (t.length) {
        var e = null;
        for (var k = 0; k < set[mType].length; k++) { if (set[mType][k].item === it) { e = set[mType][k]; break; } }
        var aon = e ? findTier(t, e.qty) : null;
        chips += t.map(function (r) {
          var on = aon && aon.threshold === r.threshold;
          return '<button type="button" class="fb-mstaffel__t' + (on ? ' is-on' : '') + '" data-fb-tier="' + r.threshold + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="Menge auf ' + r.threshold + ' Stück setzen">ab ' + r.threshold + ' · ' + eur(r.price) + '</button>';
        }).join('');
      }
      var staffel = '<div class="fb-mstaffel"><span class="fb-mstaffel__l">' + (t.length ? 'Mengenrabatt' : 'Menge') + '</span><div class="fb-mstaffel__row">' + chips + '</div></div>';
      // Kurze, konsistente Zeile wie bei Verschluessen (kein langer Produkttext mehr, 07.07.).
      // Verschluss: dynamische Passt-Garantie mit Muendung. Zubehoer: neutrale Passend-Zeile.
      var fit = isLid
        ? 'Passt garantiert auf dieses Glas' + (it.muendung ? ' (' + esc(it.muendung) + '-Mündung)' : '') + '.'
        : 'Passendes Zubehör für dieses Glas.';
      var desc = '<p class="fb-mdesc2">' + fit +
        ' <a class="fb-mlink" href="' + esc(it.url) + '">Details auf der Produktseite ›</a></p>';
      mDet.innerHTML = head + staffel + desc;
    }
    // Fuss-Button = einzige Commit-Aktion. Drei Faelle:
    //  - Auswahl vorhanden  -> "n … übernehmen · Summe"
    //  - jetzt leer, vorher aber etwas gewaehlt -> "… entfernen" (AKTIV: Entfernen muss bestaetigbar
    //    sein, sonst kann man eine Auswahl nie wieder auf Null bringen — Bugfix 07.07.)
    //  - noch nie etwas gewaehlt -> deaktiviert "… wählen" (verhindert Leerklick-Verwirrung)
    function updateDoneBtn() {
      if (!mDone) return;
      var n = sumQ(mType), tot = sumT(mType);
      if (n > 0) {
        mDone.disabled = false;
        mDone.textContent = 'Auswahl bestätigen';
      } else if (mSnapshot.length) {
        mDone.disabled = false;
        mDone.textContent = mType === 'lid' ? 'Verschlüsse entfernen' : 'Zubehör entfernen';
      } else {
        mDone.disabled = true;
        mDone.textContent = mType === 'lid' ? 'Verschluss wählen' : 'Zubehör wählen';
      }
    }
    function renderList() {
      var l = set[mType];
      var listLabel = mType === 'lid' ? 'Dein Verschluss' : 'Dein Zubehör';
      mListH.textContent = l.length ? listLabel + ' · ' + sumQ(mType) + ' Stück · ' + eur(sumT(mType)) : listLabel;
      mList.innerHTML = l.length ? l.map(function (e, i) {
        var uq = itemUnit(e.item, e.qty), u1 = itemUnit(e.item, 1);
        var sub = eur(uq) + '/Stk' + (uq < u1 - 0.0001 ? '<span class="fb-mrow__staffel">Staffelpreis angewendet</span>' : '');
        var hx = fbDot(e.item);
        var im = e.item.img
          ? '<span class="fb-mrow__im"><img src="' + esc(e.item.img) + '" alt="" loading="lazy"></span>'
          : '<span class="fb-mrow__im"></span>';
        var dot = hx ? '<span class="fb-mrow__dot" style="background:' + hx + '"></span>' : '';
        return '<div class="fb-mrow">' + im + '<span class="fb-mrow__n">' + dot + esc(e.item.name) + '<small>' + sub + '</small></span>' +
          '<div class="fb-stepper fb-stepper--sm"><button type="button" data-fb-rq="-1" data-i="' + i + '">&minus;</button><input type="text" inputmode="numeric" class="fb-stepper__in num" data-fb-rqty data-i="' + i + '" value="' + e.qty + '" aria-label="Menge"><button type="button" data-fb-rq="1" data-i="' + i + '">&plus;</button></div>' +
          '<span class="fb-mrow__p num">' + eur(itemUnit(e.item, e.qty) * e.qty) + '</span>' +
          '<button type="button" class="fb-mrow__rm" data-fb-rm="' + i + '" aria-label="Entfernen" title="Entfernen">&times;</button></div>';
      }).join('') : '<p class="fb-mempty">Wähle oben ' + (mType === 'lid' ? 'einen Verschluss' : 'ein Zubehör') + ', um fortzufahren.</p>';
      updateBadges();
      updateDoneBtn();
    }

    // Modal Events (delegiert)
    modal.querySelector('[data-fb-prev]').addEventListener('click', function () { mTrack.scrollBy({ left: -288, behavior: 'smooth' }); });
    modal.querySelector('[data-fb-next]').addEventListener('click', function () { mTrack.scrollBy({ left: 288, behavior: 'smooth' }); });
    mTrack.addEventListener('click', function (e) { var c = e.target.closest('[data-fb-card]'); if (c) selectCard(+c.getAttribute('data-fb-card')); });
    (function () { var t; mTrack.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(syncArrows, 80); }, { passive: true }); })();

    // Mengenrabatt-Chip antippen = Menge der fokussierten Karte auf die Stufe setzen (Daniel 07.07.).
    // Noch nicht gewaehlt -> mit der Stufen-Menge hinzufuegen; sonst Zeilen-Menge aktualisieren.
    mDet.addEventListener('click', function (e) {
      var glassChip = e.target.closest('[data-fb-glass]');
      var chip = e.target.closest('[data-fb-tier]');
      if (!glassChip && !chip) return;
      var thr = glassChip ? getQty() : parseInt(chip.getAttribute('data-fb-tier'), 10);
      if (isNaN(thr)) return;
      thr = Math.min(QTY_MAX, Math.max(1, thr));
      var it = active(); if (!it) return;
      var entry = null;
      for (var k = 0; k < set[mType].length; k++) { if (set[mType][k].item === it) { entry = set[mType][k]; break; } }
      if (entry) entry.qty = thr; else set[mType].push({ item: it, qty: thr });
      renderDet(); renderList();
    });

    mList.addEventListener('click', function (e) {
      var sb = e.target.closest('[data-fb-rq]'); if (sb) { var i = +sb.getAttribute('data-i'); set[mType][i].qty = Math.min(QTY_MAX, Math.max(1, set[mType][i].qty + parseInt(sb.getAttribute('data-fb-rq'), 10))); renderList(); return; }
      var rm = e.target.closest('[data-fb-rm]'); if (rm) { set[mType].splice(+rm.getAttribute('data-fb-rm'), 1); renderList(); return; }
    });
    // Fluessige Eingabe (Fix 07.07.): beim Tippen NICHT die ganze Liste neu bauen (das ersetzt
    // das Input-Feld -> Cursor verloren). Nur Modell + betroffene Zeile + Summen aktualisieren.
    mList.addEventListener('input', function (e) {
      if (!e.target.matches('[data-fb-rqty]')) return;
      var i = +e.target.getAttribute('data-i');
      var entry = set[mType][i]; if (!entry) return;
      entry.qty = Math.min(QTY_MAX, Math.max(1, parseInt((e.target.value || '1').replace(/[^0-9]/g, ''), 10) || 1));
      var row = e.target.closest('.fb-mrow');
      if (row) {
        var pEl = row.querySelector('.fb-mrow__p');
        if (pEl) pEl.textContent = eur(itemUnit(entry.item, entry.qty) * entry.qty);
        var small = row.querySelector('.fb-mrow__n small');
        if (small) {
          var uq = itemUnit(entry.item, entry.qty), u1 = itemUnit(entry.item, 1);
          small.innerHTML = eur(uq) + '/Stk' + (uq < u1 - 0.0001 ? '<span class="fb-mrow__staffel">Staffelpreis angewendet</span>' : '');
        }
      }
      if (mListH) mListH.textContent = set[mType].length ? (mType === 'lid' ? 'Dein Verschluss' : 'Dein Zubehör') + ' · ' + sumQ(mType) + ' Stück · ' + eur(sumT(mType)) : (mType === 'lid' ? 'Dein Verschluss' : 'Dein Zubehör');
      updateDoneBtn();
    });
    // Beim Verlassen des Feldes normalisieren (leere Eingabe -> 1) und Detail-Chips neu highlighten.
    mList.addEventListener('change', function (e) {
      if (!e.target.matches('[data-fb-rqty]')) return;
      renderDet(); renderList();
    });
    modal.querySelector('[data-fb-mclose]').addEventListener('click', cancelModal);
    modal.querySelector('[data-fb-mdone]').addEventListener('click', commitModal);
    // Modal liegt jetzt IM Overlay: Klicks innerhalb des Modals duerfen nicht zum
    // Overlay durchblubbern (sonst wuerde jeder Klick im Modal schliessen).
    modal.addEventListener('click', function (e) { e.stopPropagation(); });
    // Overlay-Klick (nur der Hintergrund, nicht das Modal) = abbrechen.
    ov.addEventListener('click', cancelModal);
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { cancelModal(); return; }
      // Fokus-Falle: Tab am Dialogrand zyklisch fangen (Hintergrund ist zusaetzlich inert).
      if (e.key === 'Tab') {
        var f = [].slice.call(modal.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // ================= WARENKORB =================
    function showError(msg) { if (!errEl) return; errEl.classList.remove('fb-error--info'); errEl.setAttribute('role', 'alert'); errEl.textContent = msg || 'Es ist ein Fehler aufgetreten. Bitte erneut versuchen.'; errEl.hidden = false; }
    // info=true: neutrale Hinweis-Optik (Petrol-Hauch) statt rotem Fehlerkasten — fuer
    // hilfreiche Meldungen wie die Teil-Hinzufuegung, die kein "Fehler" sind (Audit 15.07.).
    function showErrorHTML(html, info) { if (!errEl) return; errEl.classList.toggle('fb-error--info', !!info); errEl.setAttribute('role', info ? 'status' : 'alert'); errEl.innerHTML = html; errEl.hidden = false; }
    function addToCart() {
      if (!available || !variantId || atcEl.disabled) return;
      errEl && (errEl.hidden = true);
      atcEl.classList.add('is-loading'); atcEl.disabled = true;
      // Fix 09.07.: Gleiche Variante muss im Warenkorb IMMER hochzaehlen statt neue Zeile.
      // Shopify merged Zeilen nur bei identischer Variante UND identischen Properties —
      // JEDE Property (auch versteckte "_"-Properties) verhindert den Merge. Darum wird
      // hier gar keine Property mehr gesetzt (vorher: _bundle_role:'main' auf dem Haupt-
      // artikel bei Set-Konfiguration; das erzeugte eine zweite Zeile, sobald dasselbe
      // Glas spaeter lose von der PDP kam — genau der gemeldete Bug). Das Mobile-
      // "Hinzugefuegt"-Sheet erkennt den Hauptartikel jetzt ueber den Produkt-Kontext
      // (Section-Rendering ueber die PDP-URL), nicht mehr ueber eine Cart-Property.
      // Siehe fb-added-sheet.js / sections/fb-added-sheet.liquid.
      var items = [{ id: variantId, quantity: getQty() }];
      set.lid.forEach(function (e) { items.push({ id: e.item.id, quantity: e.qty }); });
      set.acc.forEach(function (e) { items.push({ id: e.item.id, quantity: e.qty }); });
      var cfg = fetchConfig(); cfg.body = JSON.stringify({ items: items });
      fetch(addUrl, cfg)
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            // 422 = Teil-Add: Shopify hat auf den verfuegbaren Bestand begrenzt, die Artikel
            // liegen aber bereits im Warenkorb. Meldung zeigen UND Warenkorb aktualisieren,
            // damit Zaehler/Drawer ohne Reload stimmen (Bugfix 08.07.). Auf Mobile still
            // aktualisieren (kein "hinzugefuegt"-Sheet, da Menge begrenzt wurde).
            var errDesc = res.d && res.d.description ? res.d.description : '';
            // Shopifys Teil-Hinzufuegungs-Meldung ("... wurden nur X ... hinzugefuegt") feuert
            // technisch bei Lagerbestand (z. B. nur 1 Stueck, Ueberverkauf aus). Darum ueber
            // Verfuegbarkeit formulieren (deckt beide Faelle) + Verweis auf den Grosshandel (15.07.).
            var addMatch = errDesc.match(/\d[\d.]*/);
            if (addMatch && /hinzugef/i.test(errDesc)) {
              showErrorHTML('Aktuell sind nur <b>' + esc(addMatch[0]) + '</b> Artikel verfügbar. Diese Menge haben wir deinem Warenkorb hinzugefügt. Für größere Mengen nutze bitte unseren <a href="/pages/grosshandel" style="color:inherit;text-decoration:underline;font-weight:700;">Großhandelsshop</a>.', true);
            } else {
              showError(errDesc || null);
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !window.matchMedia('(max-width: 767px)').matches } }));
            return;
          }
          // Mobile (04.07.): Bottom-Sheet statt Drawer-Oeffnung (Snocks-Muster);
          // Drawer wird still aktualisiert. Desktop und Fallback: Drawer wie gehabt.
          if (window.matchMedia('(max-width: 767px)').matches && window.fbAddedSheet) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
            window.fbAddedSheet.show({ productUrl: productUrl, variantId: variantId });
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          }
        })
        .catch(function () { showError(); })
        .then(function () { atcEl.classList.remove('is-loading'); atcEl.disabled = !available; });
    }

    render();
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-fb-configurator]').forEach(initOne); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
